import { useFeatureValue } from '@growthbook/growthbook-react';
import { useMemo } from 'react';
import { FEATURE_FLAG } from '../../constants/featureFlags';
import { useMarketplace } from '../../hooks/useMarketplace';
import type { LanguageConfig } from '../languages';

export const useAvailableLanguages = (): LanguageConfig => {
  const { data: marketplaceConfig } = useMarketplace();
  const languageConfiguration = useFeatureValue<LanguageConfig | null>(FEATURE_FLAG.LANGUAGE_OPTIONS, null);

  const supportedLanguages = marketplaceConfig?.marketplaceConfig?.languageConfig?.supportedLanguages;

  return useMemo(() => {
    if (!languageConfiguration || !supportedLanguages) return [];

    return languageConfiguration.filter((language) => supportedLanguages.includes(language.key));
  }, [languageConfiguration, supportedLanguages]);
};
